var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPlayNotifications(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "play-sm"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M3.34766 10.4305V3.57022C3.34766 3.06686 3.90279 2.75315 4.34482 3.00684L10.323 6.43696C10.7616 6.68866 10.7616 7.31207 10.323 7.56372L4.34482 10.9938C3.90279 11.2475 3.34766 10.9339 3.34766 10.4305Z",
    fill: "currentColor"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlayNotifications);
export default __webpack_public_path__ + "static/media/play-notifications.0866936b133878ca82f8b699ffad34ed.svg";
export { ForwardRef as ReactComponent };